import { render, staticRenderFns } from "./Co2Report.vue?vue&type=template&id=5e54b6cc&scoped=true"
import script from "./Co2Report.vue?vue&type=script&lang=ts"
export * from "./Co2Report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54b6cc",
  null
  
)

export default component.exports